import { useCallback } from 'react';
import { useEmail } from '@/context/EmailContext';

export interface ComposePrefill {
  to?: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  /** Plain-text body — converted to simple HTML for the editor. */
  body?: string;
  /** HTML body — used as-is when provided (takes precedence over body). */
  bodyHtml?: string;
  /** Lead/contact context for template rendering. */
  leadId?: string;
  contactId?: string;
}

/**
 * Open the global compose window from anywhere in the app.
 * The composer itself is mounted once in AppLayout (GlobalComposeOverlay)
 * and driven by EmailContext's composeOpen/composeDraft state.
 */
export const useComposeEmail = () => {
  const { setComposeOpen, setComposeDraft } = useEmail();

  const openCompose = useCallback((prefill: ComposePrefill = {}) => {
    setComposeDraft({
      to: prefill.to || '',
      cc: prefill.cc || '',
      bcc: prefill.bcc || '',
      subject: prefill.subject || '',
      body: prefill.body || '',
      bodyHtml: prefill.bodyHtml || '',
      attachments: [],
      leadId: prefill.leadId,
      contactId: prefill.contactId,
    });
    setComposeOpen(true);
  }, [setComposeOpen, setComposeDraft]);

  const closeCompose = useCallback(() => {
    setComposeOpen(false);
  }, [setComposeOpen]);

  return { openCompose, closeCompose };
};
